import {omneticApi as api} from '../../../../../base/src/baseApi/omneticApi';

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    abandonVehicleAuction: build.mutation<
      AbandonVehicleAuctionApiResponse,
      AbandonVehicleAuctionApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/vehicle/${queryArg.vehicleId}/auction/abandon`,
        method: 'POST',
        body: queryArg.abandonAuctionRequestBody,
        headers: {
          'X-Authorization-Profile': queryArg['X-Authorization-Profile'],
        },
      }),
    }),
    confirmVehicleAuctionWinner: build.mutation<
      ConfirmVehicleAuctionWinnerApiResponse,
      ConfirmVehicleAuctionWinnerApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/vehicle/${queryArg.vehicleId}/auction/confirm-winner`,
        method: 'POST',
        body: queryArg.confirmWinnerRequestBody,
        headers: {
          'X-Authorization-Profile': queryArg['X-Authorization-Profile'],
        },
      }),
    }),
    declineVehicleAuctionOffer: build.mutation<
      DeclineVehicleAuctionOfferApiResponse,
      DeclineVehicleAuctionOfferApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/vehicle/${queryArg.vehicleId}/auction/decline-offer`,
        method: 'POST',
        body: queryArg.declineOfferRequestBody,
        headers: {
          'X-Authorization-Profile': queryArg['X-Authorization-Profile'],
        },
      }),
    }),
    endVehicleAuctionBidding: build.mutation<
      EndVehicleAuctionBiddingApiResponse,
      EndVehicleAuctionBiddingApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/vehicle/${queryArg.vehicleId}/auction/end-bidding`,
        method: 'POST',
        headers: {
          'X-Authorization-Profile': queryArg['X-Authorization-Profile'],
        },
      }),
    }),
    getVehicleAuction: build.query<GetVehicleAuctionApiResponse, GetVehicleAuctionApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/vehicle/${queryArg.vehicleId}/auction`,
        headers: {
          'X-Authorization-Profile': queryArg['X-Authorization-Profile'],
        },
      }),
    }),
    keepVehicleAuctionInStock: build.mutation<
      KeepVehicleAuctionInStockApiResponse,
      KeepVehicleAuctionInStockApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/vehicle/${queryArg.vehicleId}/auction/keep-in-stock`,
        method: 'POST',
        headers: {
          'X-Authorization-Profile': queryArg['X-Authorization-Profile'],
        },
      }),
    }),
    publishVehicleAuction: build.mutation<
      PublishVehicleAuctionApiResponse,
      PublishVehicleAuctionApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/vehicle/${queryArg.vehicleId}/auction/publish`,
        method: 'POST',
        body: queryArg.publishAuctionRequestBody,
        headers: {
          'X-Authorization-Profile': queryArg['X-Authorization-Profile'],
        },
      }),
    }),
    relaunchVehicleAuction: build.mutation<
      RelaunchVehicleAuctionApiResponse,
      RelaunchVehicleAuctionApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/vehicle/${queryArg.vehicleId}/auction/relaunch`,
        method: 'POST',
        headers: {
          'X-Authorization-Profile': queryArg['X-Authorization-Profile'],
        },
      }),
    }),
    requestVehicleAuctionSaleBusinessCase: build.mutation<
      RequestVehicleAuctionSaleBusinessCaseApiResponse,
      RequestVehicleAuctionSaleBusinessCaseApiArg
    >({
      query: (queryArg) => ({
        url: `/dms/v1/vehicle/${queryArg.vehicleId}/auction/sale-business-case`,
        method: 'POST',
        headers: {
          'X-Authorization-Profile': queryArg['X-Authorization-Profile'],
        },
      }),
    }),
  }),
  overrideExisting: false,
});
export {injectedRtkApi as auctionApi};
export type AbandonVehicleAuctionApiResponse = /** status 200  */ AuctionView;
export type AbandonVehicleAuctionApiArg = {
  vehicleId: string;
  /** Authorization profile id */
  'X-Authorization-Profile'?: string;
  abandonAuctionRequestBody: AbandonAuctionRequestBody;
};
export type ConfirmVehicleAuctionWinnerApiResponse = /** status 200  */ AuctionView;
export type ConfirmVehicleAuctionWinnerApiArg = {
  vehicleId: string;
  /** Authorization profile id */
  'X-Authorization-Profile'?: string;
  confirmWinnerRequestBody: ConfirmWinnerRequestBody;
};
export type DeclineVehicleAuctionOfferApiResponse = /** status 200  */ AuctionView;
export type DeclineVehicleAuctionOfferApiArg = {
  vehicleId: string;
  /** Authorization profile id */
  'X-Authorization-Profile'?: string;
  declineOfferRequestBody: DeclineOfferRequestBody;
};
export type EndVehicleAuctionBiddingApiResponse = /** status 200  */ AuctionView;
export type EndVehicleAuctionBiddingApiArg = {
  vehicleId: string;
  /** Authorization profile id */
  'X-Authorization-Profile'?: string;
};
export type GetVehicleAuctionApiResponse = /** status 200  */ AuctionView;
export type GetVehicleAuctionApiArg = {
  vehicleId: string;
  /** Authorization profile id */
  'X-Authorization-Profile'?: string;
};
export type KeepVehicleAuctionInStockApiResponse = /** status 200  */ AuctionView;
export type KeepVehicleAuctionInStockApiArg = {
  vehicleId: string;
  /** Authorization profile id */
  'X-Authorization-Profile'?: string;
};
export type PublishVehicleAuctionApiResponse = /** status 200  */ AuctionView;
export type PublishVehicleAuctionApiArg = {
  vehicleId: string;
  /** Authorization profile id */
  'X-Authorization-Profile'?: string;
  publishAuctionRequestBody: PublishAuctionRequestBody;
};
export type RelaunchVehicleAuctionApiResponse = /** status 200  */ AuctionView;
export type RelaunchVehicleAuctionApiArg = {
  vehicleId: string;
  /** Authorization profile id */
  'X-Authorization-Profile'?: string;
};
export type RequestVehicleAuctionSaleBusinessCaseApiResponse = /** status 200  */ AuctionView;
export type RequestVehicleAuctionSaleBusinessCaseApiArg = {
  vehicleId: string;
  /** Authorization profile id */
  'X-Authorization-Profile'?: string;
};
export type AuctionListingView = {
  type: 'auction' | 'auction_buy_now' | 'buy_now_only';
  title: string;
  description: string;
  inspectionId: string;
  estimatedAvailabilityAt: string;
  estimatedMileage: number;
  collectionSiteId: string | null;
  publicNote: string | null;
  internalNote: string | null;
};
export type AuctionMoney = {
  amount: string;
  currency: string;
};
export type AuctionOfferView = {
  offerId: string;
  traderId: string;
  traderName: string;
  traderCompany: string | null;
  traderTier: string;
  traderRating: number | null;
  traderCity: string | null;
  traderContactName: string | null;
  traderPhone: string | null;
  traderEmail: string | null;
  traderNetwork: ('fastback' | 'local') | null;
  traderRatingsCount: number | null;
  traderTransactionsCount: number | null;
  note: string | null;
  amount: AuctionMoney;
  placedAt: string;
  correctedAt: string | null;
  rejectedAt: string | null;
  rejectionSource: ('IN_PERSON' | 'PHONE' | 'EMAIL' | 'SIGNED_DOCUMENT') | null;
  rejectionEvidence: string | null;
  rejectionNote: string | null;
};
export type AuctionTransactionView = {
  transactionId: string;
  offerId: string;
  traderId: string;
  price: AuctionMoney;
  status:
    | 'AWAITING_PAYMENT'
    | 'PAID'
    | 'DISPUTE_OPEN'
    | 'DELIVERED'
    | 'CANCELLED';
  paymentDeadlineAt: string;
  pickupDeadlineAt: string | null;
  saleBusinessCaseId: string | null;
  cancelReason: ('OWNER_DECLINED' | 'BUYER_WITHDREW' | 'VEHICLE_NOT_CONFORMING' | 'OTHER') | null;
  paidAt: string | null;
  deliveredAt: string | null;
  cancelledAt: string | null;
};
export type AuctionClocks = {
  biddingEndsAt: string | null;
  decisionDeadlineAt: string | null;
  paymentDeadlineAt: string | null;
  pickupDeadlineAt: string | null;
};
export type AuctionBlocker = {
  code:
    | 'WRONG_STATE'
    | 'BIDDING_CLOSED'
    | 'OFFER_NOT_HIGHER'
    | 'INVALID_AMOUNT'
    | 'CURRENCY_MISMATCH'
    | 'OFFER_NOT_FOUND'
    | 'CORRECTION_WINDOW_CLOSED'
    | 'CLOCK_NOT_DUE'
    | 'INVALID_TERMS'
    | 'CAR_AUDIT_MISSING'
    | 'VEHICLE_NOT_FOR_SALE'
    | 'ROUND_ALREADY_OPEN'
    | 'PURCHASE_NOT_SIGNED'
    | 'NOT_TRADE_IN'
    | 'INVALID_QUESTION'
    | 'NOT_WINNER'
    | 'OFFER_REJECTED'
    | 'EVIDENCE_REQUIRED'
    | 'SALE_PRICE_MISSING'
    | 'SALE_BUSINESS_CASE_EXISTS'
    | 'SALE_CURRENCY_MISMATCH';
  action:
    | 'publish'
    | 'confirmWinner'
    | 'declineOffer'
    | 'endBidding'
    | 'relaunch'
    | 'abandon'
    | 'keepInStock'
    | 'openDispute';
  message: string;
};
export type AuctionView = {
  roundId: string | null;
  roundNumber: number | null;
  /** A relaunched round is never the latest round. */
  state:
    | 'draft'
    | 'bidding'
    | 'decision'
    | 'expired'
    | 'awaiting_vehicle'
    | 'awaiting_pickup'
    | 'delivered'
    | 'abandoned'
    | 'kept';
  transactionStatus:
    | ('AWAITING_PAYMENT' | 'PAID' | 'DISPUTE_OPEN' | 'DELIVERED' | 'CANCELLED')
    | null;
  listing: AuctionListingView | null;
  biddingDays: number | null;
  publishedAt: string | null;
  offers: AuctionOfferView[];
  transaction: AuctionTransactionView | null;
  clocks: AuctionClocks;
  allowedActions: (
    | 'publish'
    | 'endBidding'
    | 'confirmWinner'
    | 'declineOffer'
    | 'relaunch'
    | 'abandon'
    | 'keepInStock'
    | 'openDispute'
    | 'createSaleBusinessCase'
  )[];
  blockers: AuctionBlocker[];
  /** The time when the seller closed the purchase contract of the active buying business case. */
  purchaseContractSignedAt: string | null;
};
export type Error = {
  errors?: {
    message?: string;
    code?: string;
  }[];
  validationErrors?: {
    message?: string;
    field?: string;
  }[];
};
export type AbandonAuctionRequestBody = {
  reason: 'OWNER_DECLINED' | 'BUYER_WITHDREW' | 'VEHICLE_NOT_CONFORMING' | 'OTHER';
};
export type ConfirmWinnerRequestBody = {
  offerId: string;
};
export type DeclineOfferRequestBody = {
  offerId: string;
  source: 'IN_PERSON' | 'PHONE' | 'EMAIL' | 'SIGNED_DOCUMENT';
  evidence?: string | null;
  note?: string | null;
};
export type PublishAuctionRequestBody = {
  type: 'auction' | 'auction_buy_now' | 'buy_now_only';
  title: string;
  description: string;
  inspectionId: string;
  estimatedAvailabilityAt: string;
  estimatedMileage: number;
  biddingDays: number;
  collectionSiteId?: string | null;
  publicNote?: string | null;
  internalNote?: string | null;
};
export const {
  useAbandonVehicleAuctionMutation,
  useConfirmVehicleAuctionWinnerMutation,
  useDeclineVehicleAuctionOfferMutation,
  useEndVehicleAuctionBiddingMutation,
  useGetVehicleAuctionQuery,
  useKeepVehicleAuctionInStockMutation,
  usePublishVehicleAuctionMutation,
  useRelaunchVehicleAuctionMutation,
  useRequestVehicleAuctionSaleBusinessCaseMutation,
} = injectedRtkApi;
